export const VOUCHER_TYPE_CASHBACK = 'cashBack';
const VOUCHER_TYPE_MONEYBACK = 'moneyBack';
export const VOUCHER_TYPE_GIFT = 'gift';
export const VOUCHER_TYPE_GZG50 = 'gzg50';
export const VOUCHER_TYPE_GZG200 = 'gzg200';
export const VOUCHER_TYPE_APP = 'appCashback';
export const VOUCHER_STATUS_OK = 'ok';
export const VOUCHER_STATUS_REDEEMED = 'redeemed';
export const VOUCHER_STATUS_EXPIRED = 'expired';
const VOUCHER_STATUS_INVALID = 'invalid';